import { observer } from 'mobx-react';
import ContactUs from './components/ContactUs';
import { config } from '../../constants';
import { useStores } from 'stores';
import {Row} from 'uiKit/atoms/Row/Row';
import {Col}from 'uiKit/atoms/Col/Col';

import styles from './Footer.module.scss';
import {Button} from 'uiKit/atoms/Button/Button';

const Footer = () => {
  const {
    modalStore: { showModal },
  } = useStores();

  const handleModalClick = () => showModal('LimitationLiabilityModal');

  return (
    <footer className={styles.bns3_footer}>
      <div className={styles.bns3_mainContainer}>
        <Row className={styles.bns3_footer_info} wrap="nowrap">
          <Col flex="none">
            &#169;
            {` 2020 - ${new Date().getFullYear()}. BNS Platform - `}
            <Button
              type="button"
              sx={{
                all: 'unset',
              }}
              onClick={handleModalClick}
              className={styles.bns3_liability_link}
            >
              Limitation of Liability
            </Button>
            {`. Version: ${config.version}`}
          </Col>
        </Row>
      </div>

      <ContactUs />
    </footer>
  );
};

export default observer(Footer);
